export const GET_ROLES = 'providers/AccessManagementRole/GET_ROLES';
export const CREATE_ROLE = 'providers/AccessManagementRole/CREATE_ROLE';
export const EDIT_ROLE = 'providers/AccessManagementRole/EDIT_ROLE';
export const DELETE_ROLE = 'providers/AccessManagementRole/DELETE_ROLE';
